import { CommonError } from '../../types';
import { 
    FETCH_ONGOING_CONTEST_FAILURE, 
    FETCH_ONGOING_CONTEST_REQUEST, 
    FETCH_ONGOING_CONTEST_SUCCESS,
    FETCH_CONTEST_DETAIL_FAILURE,
    FETCH_CONTEST_DETAIL_REQUEST,
    FETCH_CONTEST_DETAIL_SUCCESS
} from './constants';
import { Contest } from './types';

export interface FetchOngoingContestRequestAction {
    type: typeof FETCH_ONGOING_CONTEST_REQUEST;
}

export interface FetchOngoingContestSuccessAction {
    type: typeof FETCH_ONGOING_CONTEST_SUCCESS;
    payload: Contest;
}

export interface FetchOngoingContestFailureAction {
    type: typeof FETCH_ONGOING_CONTEST_FAILURE;
    payload: CommonError;
}

export interface FetchContestDetailRequestAction {
    type: typeof FETCH_CONTEST_DETAIL_REQUEST;
    payload: number; // contestId
}

export interface FetchContestDetailSuccessAction {
    type: typeof FETCH_CONTEST_DETAIL_SUCCESS;
    payload: Contest;
}

export interface FetchContestDetailFailureAction {
    type: typeof FETCH_CONTEST_DETAIL_FAILURE;
    payload: CommonError;
}

export type ContestActions =
    | FetchOngoingContestRequestAction
    | FetchOngoingContestSuccessAction
    | FetchOngoingContestFailureAction
    | FetchContestDetailRequestAction
    | FetchContestDetailSuccessAction
    | FetchContestDetailFailureAction;

export const fetchOngoingContestRequest = (): FetchOngoingContestRequestAction => ({
    type: FETCH_ONGOING_CONTEST_REQUEST,
});

export const fetchOngoingContestSuccess = (contest: Contest): FetchOngoingContestSuccessAction => ({
    type: FETCH_ONGOING_CONTEST_SUCCESS,
    payload: contest,
});

export const fetchOngoingContestFailure = (error: CommonError): FetchOngoingContestFailureAction => ({
    type: FETCH_ONGOING_CONTEST_FAILURE,
    payload: error,
});

export const fetchContestDetailRequest = (contestId: number): FetchContestDetailRequestAction => ({
    type: FETCH_CONTEST_DETAIL_REQUEST,
    payload: contestId,
});

export const fetchContestDetailSuccess = (contest: Contest): FetchContestDetailSuccessAction => ({
    type: FETCH_CONTEST_DETAIL_SUCCESS,
    payload: contest,
});

export const fetchContestDetailFailure = (error: CommonError): FetchContestDetailFailureAction => ({
    type: FETCH_CONTEST_DETAIL_FAILURE,
    payload: error,
});
